import { render, staticRenderFns } from "./mockTestLayout.vue?vue&type=template&id=5a368c8a&scoped=true"
import script from "./mockTestLayout.vue?vue&type=script&lang=js"
export * from "./mockTestLayout.vue?vue&type=script&lang=js"
import style0 from "./mockTestLayout.vue?vue&type=style&index=0&id=5a368c8a&prod&lang=sass"
import style1 from "./mockTestLayout.vue?vue&type=style&index=1&id=5a368c8a&prod&lang=css"
import style2 from "./mockTestLayout.vue?vue&type=style&index=2&id=5a368c8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a368c8a",
  null
  
)

export default component.exports